import React, { useEffect, useState } from "react";
import { createForm } from "@formily/core";
import { Field, VoidField } from "@formily/react";
import {
  Form,
  FormItem,
  Input,
  Submit,
  Select,
} from "@formily/antd";
import "antd/lib/button/style";
import {
  RollbackOutlined,
  DeleteOutlined,
  FileSearchOutlined
} from '@ant-design/icons';
import { Table, Button, Space, Card, Spin } from "antd";
import { request, requestkind } from '../../unit/request'
import * as datasource from '../../conf/datasource'
import { useMemo } from "react";
import Alert from "../../unit/alert"
import { Modal } from "antd";

interface Query {
  caid: string,
  customerName: string,
  createOrderType: string,
  agreementNumber: string,
  paymentWay: string,
  status: string
}

const CreditApply = () => {
  const [spinning, setSpinning] = useState<boolean>(false)
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(1)
  const [queryData, setQueryData] = useState<Query>({
    caid: "",
    customerName: "",
    createOrderType: "",
    agreementNumber: "",
    paymentWay: "",
    status: "",
  })
  const get = async (query: Query, current: number) => {
    setSpinning(true)
    const data = {
      ...query,
      pageIndex: current,
      pageSize: 10
    }
    const json = await request(data, null, requestkind.CreditApply.Search)
    console.log(json.Data)
    const { Items, TotalItemsCount } = json.Data
    Items.map((item: any, index: number) => {
      return item['key'] = index
    })
    setData(Items)
    // setCurrent(current)
    setTotal(TotalItemsCount)
    setSpinning(false)
  }
  useEffect(() => {
    get(queryData, 1)
  }, [])

  const columns = [
    {
      title: "申请编号",
      dataIndex: "Caid",
      key: "Caid",
    },
    {
      title: "下单类型",
      dataIndex: "CreateOrderType",
      key: "CreateOrderType",
      render: (text: string) => {
        if (text === "AdditionalOrder") {
          return "追加订单"
        }
        if (text === "InitialOrder") {
          return "初始订单"
        }
      }
    },
    {
      title: "客户名称",
      dataIndex: "CustomerName",
      key: "CustomerName",
    },
    {
      title: "合约编号",
      dataIndex: "AgreementNumber",
      key: "AgreementNumber",
    },
    {
      title: "申请金额",
      dataIndex: "Amount",
      key: "Amount",
      render: (amount: number) => {
        return (
          <span>{amount.toLocaleString()}</span>
        )
      }
    },
    {
      title: "付款周期",
      dataIndex: "PaymentWay",
      key: "PaymentWay",
      render: (text: string) => {
        if (text === "AnnualAdditional") {
          return "Annual"
        }
        if (text === "AnnualThreeYears") {
          return "Annual-3Yrs"
        }
        if (text === "LumpSum") {
          return "Lump Sum"
        }
      }
    },
    {
      title: "产品",
      dataIndex: "ProductType",
      key: "ProductType",
    },
    {
      title: "申请状态",
      dataIndex: "Status",
      key: "Status",
    },
    {
      title: "申请人",
      dataIndex: "CreateUser",
      key: "CreateUser",
    },
    {
      title: "申请时间",
      dataIndex: "CreateTime",
      key: "CreateTime",
    },
    {
      title: "操作",
      dataIndex: "Caid",
      key: "action",
      render: (Caid: string) => (
        <div>
          <Button icon={<FileSearchOutlined />} href={`detail/CreditApply/${Caid}`}>详情</Button>
          <Button
            icon={<DeleteOutlined />}
            onClick={async () => {
              Modal.confirm({
                title: "是否继续删除",
                onOk: async () => {
                  const res = await request({}, { caid: Caid }, requestkind.CreditApply.Delete)
                  const { IsSuccess, Msg } = res
                  if (IsSuccess) {
                    Alert.Delete.success()
                    get(queryData, 1)
                  } else {
                    Alert.Delete.error(Msg)
                  }
                }
              })
            }}>删除</Button>
          <Button
            icon={<RollbackOutlined />}
            onClick={async () => {
              Modal.confirm({
                title: "是否继续撤消",
                onOk: async () => {
                  const res = await request({}, { caid: Caid }, requestkind.CreditApply.Cancel)
                  const { IsSuccess, Msg } = res
                  if (IsSuccess) {
                    Alert.Cancel.success()
                    get(queryData, 1)
                  } else {
                    Alert.Cancel.error(Msg)
                  }
                }
              })
            }}>撤消</Button>
        </div>
      ),
    },
  ];
  const form = useMemo(
    () =>
      createForm(),
    [],
  );
  return (
    <Spin spinning={spinning} tip="获取数据中">
      <div className="search">
        <Card bordered={false} title="信用申请列表" extra={<Button type="primary" href="/creditApply/post">新建申请</Button>} style={{ width: "100%" }}>
          <Form form={form} layout="vertical" onAutoSubmit={(values: any) => {
            console.log(values)
            setCurrent(1)
            get(values, 1)
            setQueryData(values)//缓存queryData
          }}>
            <VoidField
              name="name"
              // title="姓名"
              decorator={[
                FormItem,
                {
                  asterisk: true,
                  feedbackLayout: 'none',
                },
              ]}
              component={[Space, {
              },]}
            >
              <Field
                name="Caid"
                title="申请编号"
                decorator={[FormItem]}
                initialValue=""
                component={[
                  Input,
                  {
                    style: {
                      width: 240,
                    },
                  },
                ]}
              />
              <Field
                name="CustomerName"
                title="客户名称"
                initialValue=""
                decorator={[FormItem]}
                component={[
                  Input,
                  {
                    style: {
                      width: 240,
                    },
                  },
                ]}
              />
              <Field
                name="CreateOrderType"
                title="下单类型"
                dataSource={datasource.CreateOrderType}
                initialValue=""
                decorator={[FormItem]}
                component={[Select, {
                  style: {
                    width: 240,
                  },
                }]}
              />

            </VoidField>
            <VoidField
              name="name"
              // title="姓名"
              decorator={[
                FormItem,
                {
                  asterisk: true,
                  feedbackLayout: 'none',
                },
              ]}
              component={[Space, {
                // style: {
                //     width: 600,
                // },
              },]}
            >
              <Field
                name="PaymentWay"
                title="付款周期"
                dataSource={datasource.PaymentWay}
                initialValue={""}
                decorator={[FormItem]}
                component={[
                  Select,
                  {
                    style: {
                      width: 240,
                    },
                  },
                ]}
              />
              <Field
                name="AgreementNumber"
                title="合约编号"
                initialValue=""
                decorator={[FormItem]}
                component={[
                  Input,
                  {
                    style: {
                      width: 240,
                    },
                  },
                ]}
              />
              <Field
                name="Status"
                title="申请状态"
                dataSource={datasource.Status}
                initialValue={""}
                decorator={[FormItem]}
                component={[
                  Select,
                  {
                    style: {
                      width: 240,
                    },
                  },
                ]}
              />

            </VoidField>
            <Submit className="ant-formily-item" >
              查询
              </Submit>
            <Button style={{ marginLeft: '20px' }} onClick={() => {
              form.reset()
            }} className="ant-formily-item" >
              重置
            </Button>
          </Form>
        </Card>
      </div>
      <div>
        <Card title="" bordered={false} style={{ width: "100%" }}>
          <Table columns={columns} dataSource={data} pagination={{
            simple: false,
            current: current,
            total: total,

            pageSizeOptions: ['10'],
            showSizeChanger: false,
            pageSize: 10,
            showTotal: (count = 100) => {
              return '共' + count + '条数据'
            },
            onChange: (current, pageSize) => {
              console.log(current, pageSize)
              setCurrent(current)
              get(queryData, current)
            }
          }} />
        </Card>
      </div>
    </Spin>
  );
};
export default CreditApply